module.exports = __webpack_public_path__ + "static/media/HarmoniaSansProCyr-Bold.ee8663cd.otf";